import React, { Component } from 'react';

class ModalDatosCuentaConPunta extends Component {

    constructor(props) {
        super(props);
    }

    onChangeTextArea(event) {
        let value = event.target.value;  
        this.props.valorTextArea(value); 
    }

    onClickEvent(event){
        let value = event.target.value;  

        if(this.props.value == "Ingrese motivo...")
            this.props.valorTextArea(""); 
        else
            this.props.valorTextArea(value); 
    }

    render() {
        const { titulo, mensajePrincipal, mensajeSecundario, value,nombreCampo } = this.props;
        let posicionModal = nombreCampo == "GRUPA_CUEN" ? "modalContainer-Datos-Cuenta-Posicion-GrupoAfinidad" : "modalContainer-Datos-Cuenta-Posicion-Sucursal";
        return (
            <div className='modalContainer-Datos-Cuenta'>
                <div className="Datos-Cuenta-Posicion-Modal-Denegar" >
                    <div className="arrow-up" />
                    <div className="modal-content z-index-999">
                        <div className="modal-header-Datos-Cuenta">
                            <div className="close-Datos-Cuenta" data-dismiss="modal" aria-hidden="true">
                                <label onClick={()=>this.props.openModal(2,undefined,undefined,false)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title-Datos-Cuenta">{titulo}</h2>
                        </div> 
                        <div className="modal-body">
                            <p>{mensajePrincipal}</p>
                            <p style={{fontWeight:'bold'}}>{mensajeSecundario}</p> 
                            <textarea className="textAreaBajaCuenta" maxLength="250" onClick={(event) => this.onClickEvent(event)} onChange={(event) => this.onChangeTextArea(event)} value={value} ref="input" key="input" />
                        </div>
                        <div className="modal-footer-Datos-Cuenta"> <div className="row">
                            <div className="col-x-7">
                                <button onClick={()=>this.props.denegarNovedad()} className="btn btn-Datos-Cuenta-Modal">Sí</button>
                                <button onClick={()=>this.props.openModal(2,undefined,undefined,false)} className="btn btn-secondary-Datos-Cuenta-Modal">No</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalDatosCuentaConPunta;   